import { toast } from 'sonner';
import axiosInstance from '../axiosInstance';
import { financePath } from '../../../utils/financePath';

// Action Types
export const FETCH_BANK_ACCOUNTS_REQUEST = 'FETCH_BANK_ACCOUNTS_REQUEST';
export const FETCH_BANK_ACCOUNTS_SUCCESS = 'FETCH_BANK_ACCOUNTS_SUCCESS';
export const FETCH_BANK_ACCOUNTS_FAILURE = 'FETCH_BANK_ACCOUNTS_FAILURE';

export const CREATE_BANK_ACCOUNT_REQUEST = 'CREATE_BANK_ACCOUNT_REQUEST';
export const CREATE_BANK_ACCOUNT_SUCCESS = 'CREATE_BANK_ACCOUNT_SUCCESS';
export const CREATE_BANK_ACCOUNT_FAILURE = 'CREATE_BANK_ACCOUNT_FAILURE';

export const UPDATE_BANK_ACCOUNT_REQUEST = 'UPDATE_BANK_ACCOUNT_REQUEST';
export const UPDATE_BANK_ACCOUNT_SUCCESS = 'UPDATE_BANK_ACCOUNT_SUCCESS';
export const UPDATE_BANK_ACCOUNT_FAILURE = 'UPDATE_BANK_ACCOUNT_FAILURE';

export const DELETE_BANK_ACCOUNT_REQUEST = 'DELETE_BANK_ACCOUNT_REQUEST';
export const DELETE_BANK_ACCOUNT_SUCCESS = 'DELETE_BANK_ACCOUNT_SUCCESS';
export const DELETE_BANK_ACCOUNT_FAILURE = 'DELETE_BANK_ACCOUNT_FAILURE';

// Fetch Bank Accounts
export const Fetch_BankAccounts = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_BANK_ACCOUNTS_REQUEST });

  try {
    const queryParams = {};
    
    if (params.company_id) {
      queryParams.company_id = params.company_id;
    }
    if (params.is_active !== undefined) {
      queryParams.is_active = params.is_active;
    }
    if (params.limit) {
      queryParams.limit = params.limit;
    }
    if (params.offset) {
      queryParams.offset = params.offset;
    }
    const queryString = new URLSearchParams(queryParams).toString();
    const url = queryString ? `bank/bank-accounts?${queryString}` : 'bank/bank-accounts';
    const response = await axiosInstance.get(financePath(url));

    dispatch({
      type: FETCH_BANK_ACCOUNTS_SUCCESS,
      payload: response.data.data
    });

    return response.data;
  } catch (error) {
    const errorMsg = error.response?.data?.error || 'Failed to fetch bank accounts';
    dispatch({
      type: FETCH_BANK_ACCOUNTS_FAILURE,
      payload: errorMsg
    });
    toast.error(errorMsg);
    throw error;
  }
};

// Create Bank Account
export const Create_BankAccount = (data) => async (dispatch) => {
  dispatch({ type: CREATE_BANK_ACCOUNT_REQUEST });

  try {
    const response = await axiosInstance.post(financePath('bank/bank-accounts'), data);

    dispatch({
      type: CREATE_BANK_ACCOUNT_SUCCESS,
      payload: response.data.data
    });

    toast.success('Bank account created successfully');
    return response.data;
  } catch (error) {
    const errorMsg = error.response?.data?.error || 'Failed to create bank account';
    dispatch({
      type: CREATE_BANK_ACCOUNT_FAILURE,
      payload: errorMsg
    });
    toast.error(errorMsg);
    throw error;
  }
};

// Update Bank Account
export const Update_BankAccount = (id, data) => async (dispatch) => {
  dispatch({ type: UPDATE_BANK_ACCOUNT_REQUEST });

  try {
    const response = await axiosInstance.put(financePath(`bank/bank-accounts/${id}`), data);

    dispatch({
      type: UPDATE_BANK_ACCOUNT_SUCCESS,
      payload: response.data.data
    });

    toast.success('Bank account updated successfully');
    return response.data;
  } catch (error) {
    const errorMsg = error.response?.data?.error || 'Failed to update bank account';
    dispatch({
      type: UPDATE_BANK_ACCOUNT_FAILURE,
      payload: errorMsg
    });
    toast.error(errorMsg);
    throw error;
  }
};

// Delete Bank Account
export const Delete_BankAccount = (id) => async (dispatch) => {
  dispatch({ type: DELETE_BANK_ACCOUNT_REQUEST });

  try {
    await axiosInstance.delete(financePath(`bank/bank-accounts/${id}`));

    dispatch({
      type: DELETE_BANK_ACCOUNT_SUCCESS,
      payload: id
    });

    toast.success('Bank account deleted successfully');
  } catch (error) {
    const errorMsg = error.response?.data?.error || 'Failed to delete bank account';
    dispatch({
      type: DELETE_BANK_ACCOUNT_FAILURE,
      payload: errorMsg
    });
    toast.error(errorMsg);
    throw error;
  }
};